/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestshint3Inputs */

const en_statsroomguestshint3 = /** @type {(inputs: Statsroomguestshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People without an account who came into a Live Room by code or link, and how many of them have an account now.`)
};

const de_statsroomguestshint3 = /** @type {(inputs: Statsroomguestshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menschen ohne Konto, die per Code oder Link in einen Live Room gekommen sind, und wie viele von ihnen jetzt ein Konto haben.`)
};

/**
* | output |
* | --- |
* | "People without an account who came into a Live Room by code or link, and how many of them have an account now." |
*
* @param {Statsroomguestshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestshint3 = /** @type {((inputs?: Statsroomguestshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestshint3(inputs)
	return de_statsroomguestshint3(inputs)
});
export { statsroomguestshint3 as "statsRoomGuestsHint" }